import { AfterViewInit, Component, OnInit } from '@angular/core';
import { loopOnComponents } from 'app/helpers/utils';
import { Form, Utils } from '@atefhashem/eforms';
import { MDBModalRef, ToastService } from 'ng-uikit-pro-standard';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-fields-picker-modal',
  templateUrl: './fields-picker-modal.component.html',
  styleUrls: ['./fields-picker-modal.component.scss']
})
export class FieldsPickerModalComponent implements OnInit, AfterViewInit {

  constructor(public modalRef: MDBModalRef, private toastService: ToastService) { }

  multi: boolean;
  pickedFields: string[] = [];
  uniqueID: string = '';
  form: any;
  prePickedFields: string[] = null;
  prePickRequired: boolean;
  fieldTypeFilter: string[] = null;
  formioForm: Form = null;

  pickedFieldsSubject: Subject<string[]> = new Subject;

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.pickedFields = (this.prePickedFields)? [...this.prePickedFields]: [];

    var that = this;
    var isPDFForm = (this.form.display == 'pdf');

    if (isPDFForm) {
      this.formioForm = new Form(document.getElementById('picker_eform_' + this.uniqueID), this.form, {
        isPicker: true, noAlerts: true
      });
      (that.formioForm.events as any).on('pickerComponentClick', (x)=> {
        that.toggleField(that.getComponentKey(x), x.isPicked);
      });
    } else {
      this.formioForm = new Form(document.getElementById('picker_eform_' + this.uniqueID), this.form, {
        renderMode: 'picker',
        isPicker: true,
        noAlerts: true,
        showHiddenFields: true,
        hooks: {
            attachComponent: function(element, component) {
              if (component.component.input == true && component.component.type != 'button' && component.component.type != 'datagrid') {
                element.addEventListener('mouseup', function() {
                    if (that.fieldTypeFilter && that.fieldTypeFilter.length > 0) {
                      if (!that.fieldTypeFilter.includes(component.component.type)) {
                        that.toastService.error('This field type is not allowed!');
                        return;
                      }
                    }
                    component.component.isPicked = (component.component.isPicked)? !component.component.isPicked: true;
                    component.redraw();
                    that.toggleField(that.getComponentKey(component), component.component.isPicked);
                });
              }
            }
        }
      });
    }
    this.formioForm.render();   
    
    // Pre-pick
    loopOnComponents(this.formioForm.instance, (component) => {
      if (this.prePickedFields == null) {
        if (component.component.validate && component.component.validate.required == true && this.prePickRequired == true) {
          component.component.isPicked = true;
          component.redraw();
          this.pickedFields.push(this.getComponentKey(component));
        } else {
          component.component.isPicked = false;
          component.redraw();
        }
      } else {
        if (this.prePickedFields.includes(this.getComponentKey(component))) {
          component.component.isPicked = true;
          component.redraw();
        } else {
          component.component.isPicked = false;
          component.redraw();
        }
      }  
    });
  }

  private toggleField(key: string, isPicked: boolean) {
    if (this.multi) {
      if (isPicked == true) {
        this.pickedFields.push(key);
      } else {
        this.pickedFields.splice(this.pickedFields.indexOf(key), 1);
      }

      this.pickedFields = [...this.pickedFields];

    } else {
      var that = this;
      loopOnComponents(this.formioForm.instance, function(component) {
        if (that.getComponentKey(component) != key && that.pickedFields.includes(that.getComponentKey(component))) {
            component.component.isPicked = false;
            component.redraw();
        }
      });
      if (isPicked == true) {
        this.pickedFields = [key];
      } else {
        this.pickedFields = [];
      }
    }
  }

  private getComponentKey(component: any) {
    return (<string>component.path).replace('[', '.').replace(']', '') || component.key;
  }
}
